import React from 'react';
import { Box, Button, Text } from 'theme-ui';

const Toast = ({ message, onClose }) => {

    console.log("Rendering Toast with message:", message);

    let backgroundColor = 'transparent'; // default color

    if (message.trim() === 'Profile updated successfully!') {
        backgroundColor = 'green';
    } 
    else if (message.trim() === 'No changes made to profile.') {
        backgroundColor = 'grey';
    }  
    else {
        backgroundColor = 'red';
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                backgroundColor: backgroundColor, // Use a very noticeable color for testing
                color: 'white',
                padding: '15px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 9999, // Ensure it's on top of other elements
                minWidth: '200px',
                maxWidth: '80%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <Text sx={{ flex: 1 }}>{message}</Text>
            <Button 
                onClick={onClose}
                sx={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '20px',
                    padding: '0 5px',
                    '&:hover': { opacity: 0.8 }
                }}
            >
                ×
            </Button>
        </Box>
    );
};

export default Toast;